import React, { useRef } from 'react';
import { css } from '@emotion/core';
import LotteryTaskCarouselContainer from 'client/game_checkIn/LotteryTaskCarouselContainer';
import { useSelector } from 'react-redux';
import { useLotteryTaskComponentStyle } from 'hooks/useThemeStyleIntegration';

function ResultLotteryTask({ referralCount }) {
    const taskCarouselRef = useRef(null);
    const settingStyle = useSelector(s => s.settingStyle);
    const componentStyle = useLotteryTaskComponentStyle(settingStyle);

    return (
        <div css={containerStyle}>
            <LotteryTaskCarouselContainer
                ref={taskCarouselRef}
                componentStyle={componentStyle}
                inviteCount={referralCount}
                isNeedLotteryTaskProcessHint={false}
            />
        </div>
    );
}

export default ResultLotteryTask;

const containerStyle = css`
    width: 100%;
`;
